import { useEffect } from 'react';
import { toast } from 'react-toastify';
import useApiCaller from '../hooks/use-api-caller';
import { isAuthEnabled } from '../utils/config';
import { useUnifiedAuth } from '../auth/AuthContext';

export default function IdleWatcher() {
  const TIMEOUT_IN_MINUTES = 120;

  const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

  let timeoutId: string | number | NodeJS.Timeout | undefined;

  const apiCaller = useApiCaller();
  const authEnabled = isAuthEnabled();

  const { logout: unifiedLogout } = useUnifiedAuth();
  const logout = authEnabled ? unifiedLogout : () => {};

  const handleLogout = authEnabled
    ? () => {
        logout();
        apiCaller.logout();
      }
    : () => {};

  const setInactive = () => {
    toast.info(`Logging out due to inactivity of ${TIMEOUT_IN_MINUTES} minutes!`);
    setTimeout(() => handleLogout(), 5000);
  };

  const resetTimeout = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      // Perform logout or any other action here
      setInactive();
    }, TIMEOUT_IN_MINUTES * 60000);
  };

  const onEvent = () => {
    resetTimeout();
  };

  useEffect(() => {
    events.forEach((event) => {
      document.addEventListener(event, onEvent);
    });

    resetTimeout();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      events.forEach((event) => {
        document.removeEventListener(event, onEvent);
      });
    };
  }, []);

  return <div></div>;
}
